import React from 'react';
import './UKUniversities.css'; // Reuse same CSS file for table styling

const universities = {
  A: [
    "Acadia University",
    "Algoma University",
    "Ambrose University",
    "Aurora College",
  ],
  B: [
    "Bishop’s University",
    "Brandon University",
    "Brock University",
    "Burman University",
  ],
  C: [
    "Campion College (U Regina)",
    "Canadian Mennonite University",
    "Cape Breton University",
    "Capilano University",
    "Carleton University",
    "Collège universitaire Dominicain",
    "Concordia University",
    "Concordia University of Edmonton",
    "Crandall University",
  ],
  D: [
    "Dalhousie University",
  ],
  E: [
    "École de technologie supérieure",
    "École nationale d’administration publique",
    "École Polytechnique de Montréal",
    "Emily Carr University of Art + Design",
  ],
  F: [
    "First Nations University of Canada",
  ],
  G: [
    "HEC Montréal",
  ],
  K: [
    "Kingswood University",
    "Kwantlen Polytechnic University",
  ],
  L: [
    "Lakehead University",
    "Laurentian University",
    "Luther College (U Regina)",
  ],
  M: [
    "MacEwan University",
    "McGill University",
    "McMaster University",
    "Memorial University of Newfoundland",
    "Mount Allison University",
    "Mount Royal University",
    "Mount Saint Vincent University",
  ],
  N: [
    "Nicola Valley Institute of Technology",
    "Nipissing University",
    "Northern Alberta Institute of Technology",
    "NSCAD University",
  ],
  O: [
    "OCAD University",
    "Ontario Tech University",
  ],
  P: [
    "Queen’s University",
    "Quest University Canada",
  ],
  R: [
    "Redeemer University",
    "Royal Military College of Canada",
    "Royal Roads University",
  ],
  S: [
    "Saint Mary’s University",
    "Simon Fraser University",
    "SAIT Polytechnic",
    "Southern Alberta Institute of Technology",
    "St. Francis Xavier University",
    "St. Mary’s University (Calgary)",
    "St. Stephen’s University",
    "St. Thomas More College",
    "St. Thomas University",
  ],
  T: [
    "The King’s University",
    "The University of British Columbia",
    "The University of Winnipeg",
    "Thompson Rivers University",
    "Toronto Metropolitan University",
    "Trent University",
    "Trinity Western University",
  ],
  U: [
    "Université de Hearst",
    "Université de Moncton",
    "Université de Montréal",
    "Université de Saint‑Boniface",
    "Université de Sherbrooke",
    "Université du Québec (network)",
    "Université du Québec à Chicoutimi",
    "Université du Québec à Montréal",
    "Université du Québec à Rimouski",
    "Université du Québec à Trois‑Rivières",
    "Université du Québec en Abitibi‑Témiscamingue",
    "Université du Québec en Outaouais",
    "Université Laval",
    "Université Sainte‑Anne",
    "University Canada West",
    "University of Alberta",
    "University of Calgary",
    "University of Guelph",
    "University of King’s College",
    "University of Lethbridge",
    "University of Manitoba",
    "University of New Brunswick",
    "University of Northern British Columbia",
    "University of Ottawa",
    "University of Prince Edward Island",
    "University of Regina",
    "University of Saskatchewan",
    "University of the Fraser Valley",
    "University of Toronto",
    "University of Victoria",
    "University of Waterloo",
    "University of Windsor",
  ],
  V: [
    "Vancouver Island University",
  ],
  W: [
    "Western University",
    "Wilfrid Laurier University",
  ],
  Y: [
    "York University",
    "Yorkville University",
  ]
};

const CanadaUniversities = () => {
  return (
    <div className="uk-container">
      <h2 className="uk-title">Canada Universities</h2>
      <table className="uk-table">
        <thead>
          <tr>
            <th>Letter</th>
            <th>University Name</th>
          </tr>
        </thead>
        <tbody>
          {Object.entries(universities).map(([letter, uniList]) =>
            uniList.map((uni, idx) => (
              <tr key={`${letter}-${idx}`}>
                <td>{idx === 0 ? letter : ''}</td>
                <td>{uni}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default CanadaUniversities;
